import { createVueI18nAdapter } from "vuetify/locale/adapters/vue-i18n";
import { useI18n } from "vue-i18n";
import { createVuetify as createVuetifyLib } from "vuetify";
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

export function createVuetify(i18n) {
  return createVuetifyLib({
    theme: {
      defaultTheme: "light",
      themes: {
        light: {
          colors: {
            background: "#EBEDED",
            "on-background": "#181818",
            surface: "#ffffff",
            "on-surface": "#181818",
            primary: "#3F51B5",
            "link-primary": "#3F51B5",
            "text-primary": "#3F51B5",
            "on-primary": "#FFFFFF",
            secondary: "#3f51b5",
            "on-secondary": "#FFFFFF",
            "link-secondary": "#3F51B5",
            "text-secondary": "#3F51B5",
            accent: "#21216F",
            "link-accent": "#21216F",
            "text-accent": "#21216F",
            "on-accent": "#FFFFFF",
            error: "#f44336",
            warning: "#ff9800",
            info: "#03a9f4",
            success: "#4caf50",
          },
        },
      },
    },
    locale: {
      adapter: createVueI18nAdapter({ i18n, useI18n }),
    },
    defaults: {
      VAppBar: {
        density: "comfortable",
      },
      VTextField: {
        density: "comfortable",
        variant: "outlined",
      },
      VNumberInput: {
        density: "comfortable",
        variant: "outlined",
      },
      VSelect: {
        density: "comfortable",
        variant: "outlined",
        persistentHint: true,
      },
      VSwitch: {
        color: "secondary",
        density: "comfortable",
        variant: "outlined",
        hideDetails: "auto",
        persistentHint: true,
      },
      VRadio: {
        density: "comfortable",
        variant: "outlined",
        hideDetails: "auto",
        persistentHint: true,
      },
      VCheckbox: {
        density: "comfortable",
        variant: "outlined",
        hideDetails: "auto",
        persistentHint: true,
      },
      VTextarea: {
        density: "comfortable",
        variant: "outlined",
      },
      VFileInput: {
        density: "comfortable",
        variant: "outlined",
      },
      VAutocomplete: {
        density: "comfortable",
        variant: "outlined",
        persistentHint: true,
      },
      VCombobox: {
        density: "comfortable",
        variant: "outlined",
        persistentHint: true,
      },
      VChip: {
        density: "comfortable",
        variant: "flat",
      },
      VBtn: {
        color: "secondary",
        variant: "elevated",
        rounded: "xl",
        VIcon: {
          size: "large",
        },
      },
      VCardActions: {
        VBtn: {
          color: "secondary",
          variant: "elevated",
          rounded: "xl",
          VIcon: {
            size: "large",
          },
        },
      },
      VCard: {
        rounded: "lg",
      },
      VList: {
        density: "comfortable",
        lines: "one",
      },
      VListItem: {
        density: "comfortable",
      },
      VAlert: {
        density: "comfortable",
      },
      VDialog: {
        width: "98%",
        maxWidth: "600",
      },
      VTooltip: {
        color: "white",
      },
      VToolbar: {
        density: "comfortable",
      },
      VDatePicker: {
        showAdjacentMonths: true,
      },
      VDataTable: {
        itemsPerPageOptions: [10, 25, 50, 100],
        mobile: null,
        mobileBreakpoint: "md",
      },
      VDataTableServer: {
        itemsPerPageOptions: [10, 25, 50, 100],
        mobile: null,
        mobileBreakpoint: "md",
      },
      VDataTableVirtual: {
        mobile: null,
        mobileBreakpoint: "md",
      },
      VTable: {
        mobile: null,
        mobileBreakpoint: "md",
        density: "comfortable",
      },
      VBtnToggle: {
        density: "comfortable",
        rounded: "0",
        tile: true,
        class: "flex-wrap",
      },
      VBtnGroup: {
        density: "comfortable",
        rounded: "0",
        tile: true,
        class: "flex-wrap",
        VBtn: {
          variant: "outlined",
          rounded: "0",
          class: "text-none mb-1",
          selectedClass: "btn-underlined v-btn--variant-tonal",
        },
      },
    },
  });
}
